import * as types from './types';
import { actionBuilder } from './actions';

const getters = { language: state => state.language };

const mutations = {
  [types.UI_UPDATED]: (state, { routeName }) => {
    // Implement custom UI logic here
  },
  [types.LANGUAGE_UPDATED]: (state, language) => {
    state.language = language;
  },
};

const moduleBuilder = ({ language } = {}) => {
  if (!language) {
    throw new Error('Default UI language must be set. Must be one of Login service allowed values for country');
  }

  return {
    namespaced: true,
    state: { language },
    actions: actionBuilder(),
    getters,
    mutations,
  };
};

export default {
  moduleBuilder,
  types,
};
